import MUIDivider from '@mui/material/Divider';

type DividerProps = React.ComponentProps<typeof MUIDivider>;

const Divider = ({ ...props }: Readonly<DividerProps>) => {
  return <MUIDivider {...props} />;
};

export default Divider;
